<template>
  <div style="margin: 0 0 12px;">
    <div style="display: flex; align-items: center">
      <el-input type="textarea" :rows="8" v-model="remarkForm.remark" placeholder="请输入备注信息" style="width: 100%; flex: 1"/>
    </div>
    <div class="dialog-footer" style="text-align: center; margin-top: 16px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import {updateSecurityDetailRemark} from "@/api/url";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      remarkForm: this.value.remarkForm,
    }
  },
  methods: {



    cancel() {
      this.$emit("close");
    },
    summit() {
      // if(!this.remarkForm.remark) {
      //   this.$message({
      //     showClose: true,
      //     duration: 2000,
      //     message: '请输入价格',
      //     type: 'warning'
      //   });
      //   return false
      // }
      let param = {}
      param['id'] = this.remarkForm.id
      param['remark'] = this.remarkForm.remark
      postFormData(updateSecurityDetailRemark, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },





  },
  mounted() {
  }
}
</script>

<style scoped>

</style>
